// extracted by mini-css-extract-plugin
module.exports = {"tag":"style_tag__5sxjI","fill":"style_fill___2ThA","stroke":"style_stroke__RRbZu"};